import { ConfigInterface, responseInterface } from 'swr';
import { wpApi, useWPApi, parseUrl } from '@gik/core/api';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';
import IWordpressService from '@gik/core/models/wordpress/WordpressService';
import { apiCap } from '..';

const path = 'service';

function getParams() {
  return {
    per_page: apiCap,
    filter: {
      meta_query: {
        0: {
          key: 'preview_mode',
          value: 0,
        },
      },
    },
  };
}

export function getServices() {
  const finalUrl = parseUrl(path, {
    searchParams: getParams(),
  });
  return wpApi.get(finalUrl);
}

export function useServices<Data = IWordpressService[], Error = WordpressError>(
  config?: ConfigInterface
): responseInterface<Data, Error> {
  return useWPApi<Data, Error>(path, config, { searchParams: getParams() });
}
